import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

  transform(arrivedList: any, category: string): any {
    if (!arrivedList) arrivedList = []

    const grouped = arrivedList.reduce((grouping, item) => {
      let cat = item[category];
      grouping[cat] = grouping[cat] || [];
      grouping[cat].push(item);
      return grouping;
    }, {})

    const result = Object.keys(grouped).map(key => {
      const val: any = {
        cat: key,
        catList: grouped[key]
      };

      return val;
    });

    return result;
  }
}
